import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MUNILY_ALERT_DEFAULTS, MunilyAlertType, MunilyAlertWidthLayout } from './alert.types';

@Component({
  selector: 'common-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  @Input() type: MunilyAlertType = MUNILY_ALERT_DEFAULTS.type;
  @Input() emphasisText: string = MUNILY_ALERT_DEFAULTS.emphasisText;
  @Input() description: string = MUNILY_ALERT_DEFAULTS.description;
  @Input() showDescription: boolean = MUNILY_ALERT_DEFAULTS.showDescription;
  @Input() widthLayout: MunilyAlertWidthLayout = MUNILY_ALERT_DEFAULTS.widthLayout;

  get hostClasses(): string[] {
    const classes = ['munily-alert', `munily-alert--type-${this.type}`];
    if (this.widthLayout === 'fill') classes.push('munily-alert--fill');
    return classes;
  }

  get iconLigature(): string {
    switch (this.type) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
      default:
        return 'info';
    }
  }
}

